import { useLocation } from "react-router-dom";
import { addYearTab, getYearTabList } from "../../apis/Business/Business";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./index.css";

const handleAddYear = (yearFormData, setYearTabList, setYearData) => {
  if (/^\d+$/.test(yearFormData)) {
    addYearTab({
      yearData: yearFormData,
      callback: () => {
        getYearTabList({ setYearTabList: setYearTabList });
        setYearData(yearFormData);
      },
    });
  } else {
    Swal.fire({
      title: "Error!",
      icon: "error",
      text: "Please input a valid year",
      confirmButtonColor: "#a9c1b4",
      // width: 600,
      // padding: '3em',
      color: "#476355",
      background: "#f1f8ef",
    });
  }
};

const handleYearDataChange = ({
  text,
  setYearData,
  showYearForm,
  setShowYearForm,
}) => {
  if (text === "+") {
    setShowYearForm(!showYearForm);
  } else {
    setYearData(text);
  }
};

const YearNavigationStyle = ({
  text,
  selected,
  setYearData,
  showYearForm,
  setShowYearForm,
  baselineYear,
}) => {
  return (
    <div
      className={
        "navigation__label__styleyear text-white " +
        (selected ? "__selectedyear " : "") +
        (baselineYear && text === baselineYear ? "__baseline_year " : "")
      }
      style={{
        marginLeft: selected ? "5px" : "-20px",
      }}
      onClick={() => {
        handleYearDataChange({
          text,
          setYearData,
          showYearForm,
          setShowYearForm,
        });
      }}
    >
      <h4 style={{ color: "#F1F9EF" }}>{text}</h4>
    </div>
  );
};

const YearTab = ({ setYearParent }) => {
  const location = useLocation();
  const showedLocation = [
    "/company",
    "/product",
    "/ambition",
    "/reporting",
    "/client",
  ];
  const [showYearForm, setShowYearForm] = useState(false);
  const [yearData, setYearData] = useState("");
  const [yearFormData, setYearFormData] = useState("");
  const [yearTabList, setYearTabList] = useState([]);
  const [baselineYear, setBaselineYear] = useState();

  useEffect(() => {
    if (showedLocation.includes(location.pathname)) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.set("year", yearData);
      const newUrl = `${location.pathname}?${queryParams.toString()}`;
      window.history.replaceState(null, null, newUrl);
    }
  }, [yearData, location]);

  setYearParent(yearData);

  useEffect(() => {
    getYearTabList({
      setYearTabList: setYearTabList,
      setBaselineYear: setBaselineYear,
      callback: (year) => setYearData(year),
    });
  }, []);

  // console.log(location)

  return (
    <>
      {showedLocation.includes(location.pathname) && (
        <div className="yearTab">
          {/* <div className="simulate_btn text-white p-8">
            <h5
              className="text-center"
              style={{ whiteSpace: "pre-wrap", marginTop: "10px" }}
            >
              Simulate
            </h5>
          </div> */}
          {showYearForm && (
            <div
              className="navigation__label__style text-white p-8"
              style={{
                position: "fixed",
                flexDirection: "column",
                height: "123px",
                left: "130px",
              }}
            >
              <h5
                className="text-center"
                style={{ whiteSpace: "pre-wrap", marginTop: "10px" }}
              >
                Add Year Tab
              </h5>
              <input
                type="text"
                style={{ width: "50px" }}
                placeholder={"Year"}
                value={yearFormData}
                onChange={(e) => setYearFormData(e.target.value)}
                maxLength={4}
              />
              <button
                onClick={() => {
                  handleAddYear(yearFormData, setYearTabList, setYearData);
                }}
              >
                Submit
              </button>
            </div>
          )}
          {location.pathname !== "/reporting" && (
            <YearNavigationStyle
              text={"+"}
              selected={false}
              setYearData={setYearData}
              showYearForm={showYearForm}
              setShowYearForm={setShowYearForm}
            />
          )}
          {yearTabList.map((yearTab) => {
            return (
              <YearNavigationStyle
                text={yearTab}
                selected={yearData === yearTab ? true : false}
                setYearData={setYearData}
                showYearForm={showYearForm}
                setShowYearForm={setShowYearForm}
                baselineYear={baselineYear}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default YearTab;
